import {getField, updateField} from 'vuex-map-fields';
import Quote from '@/commonFunction/baseTableModule'

let quote = new Quote('/ws/user/');

const state = {
    ...quote.state,
};
const getters = {
    ...quote.getters,
};
const actions = {
    ...quote.actions,
};
const mutations = {
    ...quote.mutations,
};

export default {
    modules: {
        User: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}
